import { render, staticRenderFns } from "./FetchPosts.vue?vue&type=template&id=75e41e7a&scoped=true"
import script from "./FetchPosts.vue?vue&type=script&lang=js"
export * from "./FetchPosts.vue?vue&type=script&lang=js"
import style0 from "./FetchPosts.vue?vue&type=style&index=0&id=75e41e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e41e7a",
  null
  
)

export default component.exports